<template>
  <div class="container">
    <div class="main">
      <div class="title">
        <div class="title_name"></div>
      </div>

      <div style="margin-bottom:32px">
        <el-image
          style="width:270px;margin-left:48px"
          :src="require('@/assets/image/brandClassroom/otherClassroomPage/otherClassroomPage3/img1.png')"
          fit="fit">
        </el-image>
      </div>
      <div class="clear">
        <el-image
          style="width:1px;margin-right:24px;float:left;margin-left:48px"
          :src="require('@/assets/image/brandClassroom/otherClassroomPage/otherClassroomPage3/img2.png')"
          fit="fit">
        </el-image>
        <el-image
          style="width:734px;float:left"
          :src="require('@/assets/image/brandClassroom/otherClassroomPage/otherClassroomPage3/img3.png')"
          fit="fit">
        </el-image>
        <el-image
          style="width:618px;float:left;margin-left:56px;margin-top:-16px;margin-bottom:47px"
          :src="require('@/assets/image/brandClassroom/otherClassroomPage/otherClassroomPage3/img4.png')"
          fit="fit">
        </el-image>
        <div style="float:left;width:735px;position:relative;">
          <el-image
            style="width:735px;float:left;"
            :src="require('@/assets/image/brandClassroom/otherClassroomPage/otherClassroomPage3/img5.png')"
            fit="fit">
          </el-image>
          <el-image
            style="width:386px;position:absolute;left:0;top:0"
            :src="require('@/assets/image/brandClassroom/otherClassroomPage/otherClassroomPage3/img6.png')"
            fit="fit">
          </el-image>
        </div>
      </div>


    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return { 

      }
    }
  }
</script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}

.title {
  position: absolute;
  width: 262px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/brandClassroom/otherClassroom/img1.png');
  background-repeat: no-repeat;
  background-size: contain;
  padding: 40px 43px 39px 46px; 
  box-sizing: border-box;
}

.title_name {
  height: 28px;
  width:  173px;
  background: url('~@/assets/image/brandClassroom/otherClassroom/img2.png');
  background-repeat: no-repeat;
  background-size: contain;
}


</style>